export default "__VITE_ASSET__7c6d7d48__"